export const listPath = '/list';
const createPath = '/create';
const editPath = '/edit';

const engagement = 'engagement';
const customer = 'customer';
const user = 'user';

const pathIdDynamic = '/:id';

const dashboardPath = '/dashboard';
const wirelinePath = '/wireline';
const escalationSupportPath = '/escalation-support';
const salesPath = '/sales';
const projectManagerPath = '/project-manager';
const contractSpecialistPath = '/contract-specialist';
const billingPath = '/billing';
const retentionManager = '/retention-manager';
const technicalOverlayPath = '/technical-overlay';

const userManagementPath = '/user-management';
const contractManagementPath = '/contract-management';

const customersPath = '/customers';

const customersIdDynamic = '/:customerId';
const wirelineEngagementsIdDynamic = '/:wirelineEngagementId';
const requestOrderIdDynamic = '/:requestOrderId';

const contractBundleIdDynamic = '/:contractBundleId';

const wirelineEngagementsPath = '/wireline-engagements';
const insideSalesRequestPath = '/inside-sales-request';
const insideSalesPath = '/inside-sales';

const sowDataPath = '/sow-data';

export const contractFormPath = '/contract-form';

export const requestOrderPath = '/request-order';

const activeNumbersPath = '/active-numbers';

const renewalSowPath = '/renewal-sow';

const dashboardPaths = {
  dashboard: dashboardPath,
  dashboardWirelinePath: `${dashboardPath}${wirelinePath}`,
  dashboardWirelineSalesPath: `${dashboardPath}${wirelinePath}${salesPath}`,
  dashboardWirelineProjectManagerPath: `${dashboardPath}${wirelinePath}${projectManagerPath}`,
  dashboardWirelineContractSpecialistPath: `${dashboardPath}${wirelinePath}${contractSpecialistPath}`,
  dashboardWirelineBillingPath: `${dashboardPath}${wirelinePath}${billingPath}`,
  dashboardWirelineInsideSalesPath: `${dashboardPath}${wirelinePath}${insideSalesPath}`,
  dashboardRetentionManagerPath: `${dashboardPath}${wirelinePath}${retentionManager}`,
  dashboardEscalationSupportPath: `${dashboardPath}${escalationSupportPath}`,
  dashboardTechnicalOverlayPath: `${dashboardPath}${wirelinePath}${technicalOverlayPath}`,
};

const insideSalesRequestPaths = {
  insideSales: insideSalesRequestPath,
};

const customerPaths = {
  customers: customersPath,
  customersList: `${customersPath}${listPath}`,
  customersCreate: `${customersPath}${createPath}-${customer}`,
  customersEdit: `${customersPath}${editPath}-${customer}${customersIdDynamic}`,
};

const userManagementPaths = {
  userManagement: userManagementPath,
  userManagementList: `${userManagementPath}${listPath}`,
  userManagementCreate: `${userManagementPath}${createPath}-${user}`,
  userManagementEdit: `${userManagementPath}${editPath}-${user}`,
  userManagementEditWithId: `${userManagementPath}${editPath}-${user}${pathIdDynamic}`,
};

const contractManagementPaths = {
  contractManagement: contractManagementPath,
  contractManagementList: `${contractManagementPath}${listPath}`,
  contractManagementListContractFormView: `${contractManagementPath}${listPath}${customersIdDynamic}${contractFormPath}${contractBundleIdDynamic}`,
};

const wirelineEngagementsPaths = {
  wirelineEngagements: wirelineEngagementsPath,
  wirelineEngagementsList: `${wirelineEngagementsPath}${listPath}`,
  wirelineEngagementsEdit: `${wirelineEngagementsPath}${editPath}-${engagement}`,
  wirelineEngagementsCreate: `${wirelineEngagementsPath}${createPath}-${engagement}`,
  wirelineEngagementsEditWithId: `${wirelineEngagementsPath}${editPath}-${engagement}${wirelineEngagementsIdDynamic}`,
  wirelineEngagementsSowData: `${wirelineEngagementsPath}${editPath}-${engagement}${wirelineEngagementsIdDynamic}${sowDataPath}${customersIdDynamic}`,
  wirelineEngagementsRenewalSow: `${wirelineEngagementsPath}${editPath}-${engagement}${wirelineEngagementsIdDynamic}${renewalSowPath}${customersIdDynamic}`,
  wirelineEngagementsActiveNumbers: `${wirelineEngagementsPath}${editPath}-${engagement}${wirelineEngagementsIdDynamic}${activeNumbersPath}${customersIdDynamic}`,
  wirelineEngagementsRequestOrder: `${wirelineEngagementsPath}${editPath}-${engagement}${wirelineEngagementsIdDynamic}${sowDataPath}${customersIdDynamic}${requestOrderPath}`,
  wirelineEngagementsSowDataContractForm: `${wirelineEngagementsPath}${editPath}-${engagement}${wirelineEngagementsIdDynamic}${sowDataPath}${customersIdDynamic}${contractFormPath}`,
  wirelineEngagementsRenewalSowContractForm: `${wirelineEngagementsPath}${editPath}-${engagement}${wirelineEngagementsIdDynamic}${renewalSowPath}${customersIdDynamic}${contractFormPath}`,
  wirelineEngagementsRequestOrderView: `${wirelineEngagementsPath}${editPath}-${engagement}${wirelineEngagementsIdDynamic}${sowDataPath}${customersIdDynamic}${requestOrderPath}${requestOrderIdDynamic}`,
  wirelineEngagementsSowContractFormView: `${wirelineEngagementsPath}${editPath}-${engagement}${wirelineEngagementsIdDynamic}${sowDataPath}${customersIdDynamic}${contractFormPath}${contractBundleIdDynamic}`,
  wirelineEngagementsRenewalContractFormView: `${wirelineEngagementsPath}${editPath}-${engagement}${wirelineEngagementsIdDynamic}${renewalSowPath}${customersIdDynamic}${contractFormPath}${contractBundleIdDynamic}`,
};

const paths = {
  mobilityEngagements: '/mobility-engagements',
  mobilityRequests: '/mobility-requests',
  customerSupportRequests: '/customer-support-requests',

  ...dashboardPaths,
  ...wirelineEngagementsPaths,
  ...insideSalesRequestPaths,
  ...customerPaths,
  ...userManagementPaths,
  ...contractManagementPaths,
};

export const getUserEditPath = (id) => `${userManagementPath}${editPath}-${user}/${id}`;

export const getCustomersEditPath = (id) => `${customersPath}${editPath}-${customer}/${id}`;
export const getEngagementsEditPath = (id) => `${wirelineEngagementsPath}${editPath}-${engagement}/${id}`;

export const getSowDataPath = (engagementsId, customerId) => `${getEngagementsEditPath(engagementsId)}${sowDataPath}/${customerId}`;

export const getActiveNumbersPath = (engagementsId, customerId) => `${getEngagementsEditPath(engagementsId)}${activeNumbersPath}/${customerId}`;

export const getRenewalSowPath = (engagementsId, customerId) => `${getEngagementsEditPath(engagementsId)}${renewalSowPath}/${customerId}`;

export const getContractManagementContractFormView = (customerId, contractBundleId) => `${contractManagementPaths.contractManagementList}/${customerId}${contractFormPath}/${contractBundleId}`;

export default paths;
